import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { contributorsList } from '../selectors';
import { CreateOwnershipSuccess } from '../../ownership/action-creators';
import { CREATE_OWNERSHIP_SUCCESS } from '../../ownership/actions';
import { NewCollaborator } from '@services/collaborator/types/new-collaborator';
import { CreateCollaborator } from '../action-creators';
import { FugaContributorRole } from '@services/publisher/types/FugaContributorRole';

/**
 *
 * This effect creates a collaborator after a successful Songwriter Creation
 *
 */

export const createCollaboratorForSongwriter = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, CreateOwnershipSuccess>(CREATE_OWNERSHIP_SUCCESS),
    filter(
      (action) =>
        action.ownership.ownershipType === 'WRITER' &&
        action.ownership.ownerType === 'USER' &&
        !action.isReplicatingFromFirstTrack
    ),
    withLatestFrom(state$),
    map(([action, state]) => {
      const newCollaborator: NewCollaborator = {
        assetId: action.ownership.assetId,
        assetType: 'TRACK',
        type: 'CONTRIBUTOR',
        name: action.ownership.name,
        contact: action.ownership.contact,
        contactType: action.ownership.contactType,
        role: 'Composer',
        collaboratorType: 'USER',
        collaboratorId: action.ownership.ownerId,
        order: action.ownership.order,
        releaseId: state.release.release?.id,
      };

      return new CreateCollaborator(
        newCollaborator,
        action.isReplicatingFromFirstTrack
      );
    })
  );

export const getRole = (
  state: AppState,
  assetId: string
): FugaContributorRole => {
  const contributors = contributorsList(state.collaborator, assetId);

  if (!contributors.find((c) => c.role === 'Composer')) {
    return 'Composer';
  }

  if (
    state.tracks.tracks[assetId].lyrics &&
    !contributors.find((c) => c.role === 'Lyricist')
  ) {
    return 'Lyricist';
  }

  return 'Composer';
};
